import request from '@/utils/request'
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 积分明细查询
export function getIntegralDetail (data) {
    return request({
        url: GateWay + '/mainPlatform/selectIntegralDetail',
        method: 'post',
        data
    })
}
// 积分用户查询
export function getUserIntegral (data) {
    return request({
        url: GateWay + '/handleWx/queryPoints',
        method: 'post',
        data
    })
}